import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-info',
  templateUrl: './delete-info.component.html',
  styleUrls: ['./delete-info.component.scss']
})
export class DeleteInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
